import React, {useMemo} from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {useHistory} from "react-router-dom";
import moment from "moment/moment";
import {InstructorProgramCourseSelection} from "../Providers/InstructorProgramsProvider";

type Props = {
    courses: InstructorProgramCourseSelection[]
    programId : string;
};

const columns = [
    {
        dataField: 'courseSelectionUUID',
        hidden: true,
        text: ''
    },
    {
        dataField: 'registrations',
        text: 'Registrations',
        sort: false,
    },
    {
        dataField: 'subject',
        text: 'Subject',
        sort: true,
        classes: 'd-none d-lg-table-cell',
        headerClasses: 'd-none d-lg-table-cell',
    },
    {
        dataField: 'courseNumber',
        text: 'COURSE #',
        sort: true,
        classes: 'd-none d-lg-table-cell',
        headerClasses: 'd-none d-lg-table-cell',
    },
    {
        dataField: 'sectionNumber',
        text: 'SECTION #',
        sort: true,
        classes: 'd-none d-lg-table-cell',
        headerClasses: 'd-none d-lg-table-cell',
    },
    {
        dataField: 'name',
        text: 'DESCRIPTION',
        sort: true
    },
    {
        dataField: 'term',
        text: 'Term',
        sort: true,
        classes: 'd-none d-lg-table-cell',
        headerClasses: 'd-none d-lg-table-cell',
    },
    {
        dataField: 'dates',
        text: 'DATES',
        sort: true
    },
    {
        dataField: 'meetingDays',
        text: 'DAYS',
        sort: true,
        classes: 'd-none d-lg-table-cell',
        headerClasses: 'd-none d-lg-table-cell',
    },
    {
        dataField: 'meetingTime',
        text: 'TIME',
        sort: true,
        classes: 'd-none d-lg-table-cell',
        headerClasses: 'd-none d-lg-table-cell',
    },
];

const InstructorCourseList = ({
    courses,
    programId,
} : Props) => {
    const history = useHistory();
    const display = useMemo(() => courses.map(course => ({

        registrations :<a
            onClick={() => {
                history.push(`/instructor/course/${programId}/${course.id}`);
            }}
            href={'#'}
        >View Registrations</a>,
        courseSelectionUUID : course.id,
        subject : course.course?.subject ?? '',
        term : course.sectionTerms[0]?.term?.semester ?? '',
        sectionNumber : course.sectionNumber ?? '',
        courseNumber : course.course?.courseNumber ?? '',
        name : <a
            onClick={() => {
            history.push(`/instructor/course/${programId}/${course.id}`);
            }}
            href={'#'}
        >{course.course.courseName}</a>,
        dates : course.meetingDateStart ?
            `${moment(course.meetingDateStart).format('l')} - ${moment(course.meetingDateEnd).format('l')}`
            : '',
        meetingDays : course.meetingDaysOfWeek ?
            course.meetingDaysOfWeek.replace('\r', ', ')
            : '',
        meetingTime : course.meetingTimeStart ?
            moment(course.meetingTimeStart, 'hh:mm:ss').format('LT')
            : '',
    })), [courses]);


    return (
                <BootstrapTable
                    bootstrap4
                    keyField='courseSelectionUUID'
                    data={display}
                    columns={columns}
                    pagination={paginationFactory({sizePerPage: 40}) }
                    striped
                />
    );
};

export default InstructorCourseList;
